import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Typography, Badge, Button, Space, Col, Row } from "antd";
import { Shield, Users, Plus, Lock, Unlock, X as CloseIcon } from "react-feather";

const { Title, Text } = Typography;

// Mock data
const mockRole = {
    id: 'admin',
    name: 'Admin',
    description: 'Full system access and management',
    status: 'active'
};

const mockResources = [
    { id: 1, name: 'Create Product' },
    { id: 2, name: 'Create Underwriter' },
    { id: 3, name: 'View Report' },
    { id: 4, name: 'Manage Users' },
    { id: 5, name: 'Edit Settings' }
];

const mockUsers = [
    { id: 1, name: 'Phares' },
    { id: 2, name: 'Kevin' },
    { id: 3, name: 'Jane' }
];

const ViewUserModuleRole = () => {
    const { id } = useParams();
    const [role, setRole] = useState(mockRole);
    const [resources, setResources] = useState(mockResources);
    const [assignedUsers, setAssignedUsers] = useState(mockUsers);

    const handleToggleStatus = () => {
        setRole(prev => ({
            ...prev,
            status: prev.status === 'active' ? 'inactive' : 'active'
        }));
    };

    const handleAddResource = () => {
        console.log('Add resource');
    };

    const handleAddUser = () => {
        console.log('Add user to role');
    };

    const handleRemoveResource = (resourceId) => {
        setResources(prev => prev.filter(r => r.id !== resourceId));
    };

    const handleRemoveUser = (userId) => {
        setAssignedUsers(prev => prev.filter(u => u.id !== userId));
    };

    const getStatusColor = (status) => {
        return status === 'active' ? '#52c41a' : '#ff4d4f';
    };

    return (
        <div style={{ minHeight: '100vh', background: '#f8fafc', padding: '24px' }}>
            <Card 
                style={{ 
                    marginBottom: '24px', 
                    borderRadius: '12px', 
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)', 
                    border: 'none' 
                }}
                title={
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <Shield size={24} style={{ color: '#1890ff' }} />
                            <div>
                                <Text type="secondary" style={{ fontSize: '14px', display: 'block' }}>Role</Text>
                                <Title level={3} style={{ margin: 0, color: '#1890ff', fontWeight: 600 }}>
                                    {role.name}
                                </Title>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                            <Badge 
                                color={getStatusColor(role.status)} 
                                text={role.status.toUpperCase()}
                                style={{ fontSize: '12px', fontWeight: '600' }}
                            />
                            <Button 
                                type="primary" 
                                danger={role.status === 'active'}
                                onClick={handleToggleStatus}
                                icon={role.status === 'active' ? <Lock size={16} /> : <Unlock size={16} />}
                            >
                                {role.status === 'active' ? 'Deactivate' : 'Activate'}
                            </Button>
                        </div>
                    </div>
                }
            >
                <Text style={{ fontSize: '14px', color: '#6b7280' }}>
                    {role.description}
                </Text>
            </Card>

            {/* Resources Section */}
            <Card 
                style={{ 
                    marginBottom: '24px', 
                    borderRadius: '12px', 
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)', 
                    border: 'none' 
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <Title level={4} style={{ margin: 0, color: '#1f2937' }}>Resources</Title>
                    <Button 
                        type="primary" 
                        onClick={handleAddResource}
                        icon={<Plus size={16} />}
                    >
                        Add Resource
                    </Button>
                </div>
                <Row gutter={[16, 16]}>
                    {resources.map(resource => (
                        <Col xs={24} sm={12} md={8} lg={6} key={resource.id}>
                            <Card 
                                style={{ 
                                    borderRadius: '8px', 
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)', 
                                    position: 'relative' 
                                }}
                            >
                                <Button 
                                    type="text" 
                                    icon={<CloseIcon size={16} />} 
                                    onClick={() => handleRemoveResource(resource.id)}
                                    style={{ position: 'absolute', top: 8, right: 8, color: '#ff4d4f' }}
                                />
                                <Text style={{ fontSize: '14px', fontWeight: 500, color: '#1f2937' }}>
                                    {resource.name}
                                </Text>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Card>

            {/* Assigned Users Section */}
            <Card 
                style={{ 
                    borderRadius: '12px', 
                    boxShadow: '0 4px 20px rgba(0,0,0,0.08)', 
                    border: 'none' 
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <Title level={4} style={{ margin: 0, color: '#1f2937' }}>Assigned Users</Title>
                    <Button 
                        type="primary" 
                        onClick={handleAddUser}
                        icon={<Plus size={16} />}
                    >
                        Add User
                    </Button>
                </div>
                <Row gutter={[16, 16]}>
                    {assignedUsers.map(user => (
                        <Col xs={24} sm={12} md={8} lg={6} key={user.id}>
                            <Card 
                                style={{ 
                                    borderRadius: '8px', 
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)', 
                                    position: 'relative' 
                                }}
                            >
                                <Button 
                                    type="text" 
                                    icon={<CloseIcon size={16} />} 
                                    onClick={() => handleRemoveUser(user.id)}
                                    style={{ position: 'absolute', top: 8, right: 8, color: '#ff4d4f' }}
                                />
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Users size={20} style={{ color: '#1890ff' }} />
                                    <Text style={{ fontSize: '14px', fontWeight: 500, color: '#1f2937' }}>
                                        {user.name}
                                    </Text>
                                </div>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Card>
        </div>
    );
};

export default ViewUserModuleRole;